module.exports = __webpack_public_path__ + "img/Group 1108one6.21c124c2.png";